import { getParticipantByProjectIdWithHaveRoleStatus, deleteParticipantByParticipantId, updateParticipant, createParticipant } from "@/apis"
import pLimit from "p-limit"
import {
    PARTICIPANT_HAVE_ROLE_LIST,
    PARTICIPANT_NO_ROLE_LIST,
    PARTICIPANT_REMOVE,
    PARTICIPANT_ERROR,
    PARTICIPANT_PENDING,
    PARTICIPANT_PENDING_DONE,
    PARTICIPANT_UPDATE,
    PARTICIPANT_ADD,
} from "../action-types/participant"

import { ACTIVATE_PROCESS_INIT, ACTIVATE_PROCESS_DONE, ACTIVATE_PROCESS_PROCESSING } from "../action-types/activateProjectProcess"

export const getParticipantHaveRoleByProjectId = (projectId) => async (dispatch) => {
    const haveRole = true
    try {
        const resultParticipantData = await getParticipantByProjectIdWithHaveRoleStatus({ projectId, haveRole })
        const resultParticipant = resultParticipantData.data
        dispatch({ type: PARTICIPANT_HAVE_ROLE_LIST, payload: resultParticipant.participants })
    } catch (error) {
        dispatch({ type: PARTICIPANT_ERROR, payload: { message: "retrieve participant failed", mainPageError: true } })
    } finally {
        dispatch({ type: PARTICIPANT_PENDING_DONE })
    }
}

export const getParticipantNotRoleByProjectId = (projectId) => async (dispatch) => {
    const haveRole = false
    try {
        const resultParticipantData = await getParticipantByProjectIdWithHaveRoleStatus({ projectId, haveRole })
        const resultParticipant = resultParticipantData.data
        dispatch({ type: PARTICIPANT_NO_ROLE_LIST, payload: resultParticipant.participants })
    } catch (error) {
        dispatch({ type: PARTICIPANT_ERROR, payload: { message: "retrieve participant failed", mainPageError: true } })
    } finally {
        dispatch({ type: PARTICIPANT_PENDING_DONE })
    }
}

export const deleteParticipantRequest =
    ({ participantId, noRoleSet, projectId }) =>
    async (dispatch) => {
        dispatch({ type: PARTICIPANT_PENDING })
        try {
            await deleteParticipantByParticipantId(participantId, projectId)
            dispatch({ type: PARTICIPANT_REMOVE, payload: { participantId, noRoleSet } })
        } catch (e) {
            dispatch({ type: PARTICIPANT_ERROR, payload: { message: e.data.message, mainPageError: false } })
        } finally {
            dispatch({ type: PARTICIPANT_PENDING_DONE })
        }
    }

export const addParticipantRequest = (participantDetail) => async (dispatch) => {
    try {
        const result = await createParticipant(participantDetail)
        const newParticipantData = result.data.participant
        delete newParticipantData.projects
        dispatch({ type: PARTICIPANT_ADD, payload: { participant: newParticipantData } })
    } catch (e) {
        dispatch({ type: PARTICIPANT_ERROR, payload: e.message })
    } finally {
        dispatch({ type: PARTICIPANT_PENDING_DONE })
    }
}

export const bulkAddParticipant = (participantList, projectId) => async (dispatch) => {
    const totalNumber = participantList.length
    let processedTask = 0
    let processMessage = ""
    dispatch({ type: ACTIVATE_PROCESS_INIT, payload: totalNumber })
    if (totalNumber > 0) {
        const limit = pLimit(5)
        const participants = participantList
        const promises = participants.map((participant) => {
            const participantNewDetail = {
                firstName: participant.firstName,
                lastName: participant.lastName,
                email: participant.email,
                projectId,
            }
            // wrap the function we are calling in the limit function we defined above
            return limit(async () => {
                const result = await createParticipant(participantNewDetail)
                const newParticipantData = result.data.participant
                delete newParticipantData.projects
                dispatch({ type: PARTICIPANT_ADD, payload: { participant: newParticipantData, messagePopup: false } })
                processedTask++
                processMessage = `Processing adding participant`
                dispatch({ type: ACTIVATE_PROCESS_PROCESSING, payload: { processedTask, processMessage } })
            })
        })
        ;(async () => {
            // Only three promises are run at once (as defined above)
            const addParticipantResults = await Promise.allSettled(promises)
            dispatch({ type: ACTIVATE_PROCESS_DONE, payload: { processedTask, results: addParticipantResults } })
        })()
    } else {
        dispatch({ type: ACTIVATE_PROCESS_DONE, payload: { processedTask, results: [] } })
    }
}

export const updateParticipantRequest = (participantDetail) => async (dispatch) => {
    try {
        const result = await updateParticipant(participantDetail)
        const newParticipantData = result.data.participant
        delete newParticipantData.projects
        const noRoleStatus = !newParticipantData.roleId
        dispatch({ type: PARTICIPANT_UPDATE, payload: { noRoleStatus, participant: newParticipantData } })
    } catch (e) {
        dispatch({ type: PARTICIPANT_ERROR, payload: e.data.message })
    } finally {
        dispatch({ type: PARTICIPANT_PENDING_DONE })
    }
}
